import { styled } from '@mui/system';

export const MainCard = styled('div')<{ rounded?: boolean }>(
  ({ rounded = true }) => ({
    position: 'relative',
    width: '100%',
    background: 'white',
    border: '1px solid #eaeaea',
    borderRadius: rounded ? 10 : 0,
  }),
);
